import React from 'react';
import PropTypes from 'prop-types';
import HeaderSection from '../components/HeaderSection';
import InfoSection from '../components/InfoSection';
import InputSection from '../components/InputSection';
import ButtonSection from '../components/ButtonSection';
import { PIN, DEFAULT, DESACTIVE } from '../constants';

const Desactive = ({
  label,
  labelBtn,
  loading,
  errors,
  form,
  onChange,
  onSave,
  onToggle,
}) => (
  <div>
    <HeaderSection labelTitle={label.title} labelSubtitle={label.subTitle} />

    <div className="row padding-top-1">
      <InfoSection
        className="col-md-6 padding-bottom-2"
        labelTitle={label.desactive.title}
        labelDescription={label.desactive.description}
      />

      <InputSection
        className="col-lg-4 col-md-6 col-xs-12"
        placeholder={label.input.placeholder}
        name={PIN}
        label={label.input.text1}
        error={errors.pin}
        value={form.pin || ''}
        onChange={onChange}
      />
    </div>

    <ButtonSection
      labelCancel={labelBtn.btnCancel}
      labelExec={labelBtn.btnDesactive}
      loading={loading}
      onToggle={() => onToggle(DEFAULT)}
      onExec={() => onSave(DESACTIVE)}
    />
  </div>
);

Desactive.propTypes = {
  errors: PropTypes.object,
  label: PropTypes.object,
  labelBtn: PropTypes.object,
  loading: PropTypes.bool,
  form: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};
export default Desactive;
